import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "input-error" }
const _hoisted_7 = { class: "col-lg-4 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = {
  key: 0,
  class: "input-error"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-4 col-sm-6" }
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "input-error"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre del Promotor",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company.name) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('name')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.errors.name), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label text-secondary" }, "RUC", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el RUC del Promotor",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.ruc) = $event)),
                maxlength: "11",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('ruc')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.ruc,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.ruc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errors.ruc), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                style: {"resize":"none"},
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar la descripción del Promotor",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.description) = $event)),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('description')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.description,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errors.description), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_RouterLink, { to: "/promotors" }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.company.id == 0 ? "Crear" : "Actualizar"), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_17)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}